export default __webpack_public_path__ + "static/media/ic-xls.10f98512.png";